import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import applyForm from './applyForm.vue';
import ticketForm from './ticketForm.vue';
import saleCreateOrder from './components/saleCreateOrder.vue';
import saleOrderList from './components/saleOrderList.vue';
import { getCustomerList } from '@/views/cardSystem/customer/api/index';
import { formatApprover } from './defaultForms';
import { getInitiatedByMe, submitProjectDeliveryAcceptance, submitCardAndCouponDesignConfirm, getPrintingInfo, getProjectTicketSelect, getProjectTicketInitiatedList, getSaleProjectDeliveryOrders } from '../api';
export default {
  components: {
    applyForm: applyForm,
    ticketForm: ticketForm,
    saleCreateOrder: saleCreateOrder,
    saleOrderList: saleOrderList
  },
  data: function data() {
    return {
      tabActiveName: '1',
      companyList: [],
      searchForm: {
        number: '',
        status: [],
        type_of_demand: [],
        customer_id: null,
        project_name: '',
        project_type: [],
        type: [],
        pageSize: 20,
        page: 1
      },
      listData: [],
      listPages: {
        currentPage: 1,
        totalCount: 0
      },
      applyFormVisible: false,
      applyFormType: 'add',
      selectedId: null,
      selectedProjectType: null,
      selectedProjectStatus: null,
      selectedRejectedTaskTypes: [],
      drawerTitle: '装修&项目交付申请',
      designConfirmVisible: false,
      designFileList: [],
      currentDesignRow: null,
      need_printing: null,
      // second_category_id 为 cascader 多选格式（数组的数组：[一级id, 二级id]），查询时取叶子 id
      ticketSearchForm: {
        work_order_no: '',
        title: '',
        second_category_id: [],
        item: '',
        page: 1,
        pageSize: 20
      },
      ticketListData: [],
      ticketListPages: {
        currentPage: 1,
        totalCount: 0
      },
      ticketCategoryTree: [],
      ticketDrawerVisible: false,
      ticketFormId: null,
      ticketFormType: 'add',
      ticketFormCustomerName: '',
      multiOrderVisible: false,
      orderListVisible: false,
      selectedOrderId: null,
      createOrderDrawer: false,
      orderLoadingId: null,
      // 创建订单抽屉基于的订单号：首次下单=虚拟订单号，继续下单=勾选要复制卡规则的订单号
      orderDrawerId: null,
      saleProjectDeliveryId: null,
      viewOrderRow: null,
      orderListLoading: false,
      orderListPages: {
        currentPage: 1,
        totalCount: 0
      },
      // 报价单订单列表与金额汇总
      saleOrderList: [],
      orderSummary: {
        quotation: '',
        used: '',
        available: ''
      }
    };
  },
  created: function created() {
    var _this = this;
    var tabList = [{
      name: '1',
      permission: '/user/project-delivery/ticket-initiated-by-me'
    }, {
      name: '2',
      permission: '/user/project-ticket/ticket-initiated-by-me'
    }];
    var firstVisibleTab = tabList.find(function (item) {
      return _this.$hasBtnRoles(item.permission);
    });
    if (firstVisibleTab) this.tabActiveName = firstVisibleTab.name;
    this.getCompanyList();
    if (this.tabActiveName === '2') {
      this.initTicketTab();
    }
    this.getlist();
  },
  computed: {
    imageSrcList: function imageSrcList() {
      var _this2 = this;
      return this.designFileList.filter(function (item) {
        return _this2.isImageFile(item);
      }).map(function (item) {
        return _this2.$ossurl + item.url;
      });
    }
  },
  methods: {
    formatApprover: formatApprover,
    // 报价单任务（type_of_demand 中 type=9）是否处于指定状态：300 已完成 / 800 已失效
    hasQuotationTaskStatus: function hasQuotationTaskStatus(row, status) {
      return (row.type_of_demand || []).some(function (item) {
        return Number(item.type) === 9 && Number(item.status) === status;
      });
    },
    isImageFile: function isImageFile(item) {
      var imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
      var fileExtension = (item.url || item.file_name || '').split('.').pop().toLowerCase();
      return imageExtensions.includes(fileExtension);
    },
    getCompanyList: function getCompanyList(val) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getCustomerList({
                page_size: 200,
                name: val || '',
                is_delete: 0
              });
            case 1:
              res = _context.v;
              _this3.companyList = res.data.list;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getlist: function getlist() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(_this4.tabActiveName === '2')) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return getInitiatedByMe(_this4.searchForm);
            case 2:
              res = _context2.v;
              _this4.listData = res.data.data;
              _this4.listPages = res.pages;
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    handleTabClick: function handleTabClick(tab) {
      if (tab.name === this.tabActiveName) return;
      this.tabActiveName = tab.name;
      if (tab.name === '2') {
        this.initTicketTab();
        return;
      }
      this.resetList();
    },
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      this.getlist();
      var dom = document.getElementById('searchDom');
      dom.scrollIntoView();
    },
    sizeChange: function sizeChange(size) {
      this.searchForm.pageSize = size;
      this.searchForm.page = 1;
      this.getlist();
    },
    resetList: function resetList() {
      this.searchForm.page = 1;
      this.getlist();
    },
    handleClose: function handleClose() {
      this.getlist();
    },
    viewDetail: function viewDetail(row) {
      this.selectedId = row.id;
      this.selectedProjectType = row.project_type;
      this.selectedProjectStatus = row.status;
      this.applyFormType = 'view';
      this.drawerTitle = '装修&项目交付申请（项目ID：' + row.number + '）';
      this.applyFormVisible = true;
    },
    toCreate: function toCreate() {
      this.selectedId = null;
      this.selectedProjectType = null;
      this.selectedProjectStatus = null;
      this.applyFormType = 'add';
      this.drawerTitle = '装修&项目交付申请';
      this.applyFormVisible = true;
    },
    toAgain: function toAgain(row) {
      this.selectedId = row.id;
      this.selectedProjectType = row.project_type;
      this.selectedProjectStatus = row.status;
      this.selectedRejectedTaskTypes = (row.type_of_demand || []).filter(function (item) {
        return item.status == 400 || Number(item.type) === 9 && item.status == 800;
      }).map(function (item) {
        return String(item.type);
      });
      this.applyFormType = 'add';
      this.drawerTitle = '装修&项目交付申请（项目ID：' + row.number + '）';
      this.applyFormVisible = true;
    },
    toAccept: function toAccept(row) {
      var _this5 = this;
      this.selectedId = row.id;
      this.$confirm('确定验收通过？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.submitAcceptance();
      });
    },
    submitAcceptance: function submitAcceptance() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return submitProjectDeliveryAcceptance({
                id: _this6.selectedId
              });
            case 1:
              res = _context3.v;
              _this6.$message.success('验收成功');
              _this6.applyFormVisible = false;
              _this6.getlist();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    openDesignConfirm: function openDesignConfirm(row) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res, designDraft;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this7.currentDesignRow = row;
              _this7.need_printing = null;
              _this7.designFileList = [];
              _context4.n = 1;
              return getPrintingInfo({
                id: row.id
              });
            case 1:
              res = _context4.v;
              designDraft = res.data && res.data.design_draft;
              _this7.designFileList = Array.isArray(designDraft) ? designDraft : [];
              _this7.need_printing = res.data && res.data.need_printing;
              _this7.designConfirmVisible = true;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    downloadDesignFile: function downloadDesignFile(file) {
      if (file.url) {
        window.open(this.$ossurl + file.url, '_blank');
      }
    },
    confirmDesign: function confirmDesign() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (_this8.currentDesignRow) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              if (_this8.need_printing) {
                _context5.n = 2;
                break;
              }
              _this8.$message.warning('请选择是否需要印刷');
              return _context5.a(2);
            case 2:
              _context5.n = 3;
              return submitCardAndCouponDesignConfirm({
                id: _this8.currentDesignRow.id,
                need_printing: _this8.need_printing
              });
            case 3:
              _this8.$message.success('设计确认成功');
              _this8.designConfirmVisible = false;
              _this8.getlist();
            case 4:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    initTicketTab: function initTicketTab() {
      if (!this.ticketCategoryTree.length) {
        this.getTicketCategoryTree();
      }
      this.getTicketList();
    },
    getTicketCategoryTree: function getTicketCategoryTree() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return getProjectTicketSelect();
            case 1:
              res = _context6.v;
              _this9.ticketCategoryTree = res.data && res.data.tree || [];
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getTicketList: function getTicketList() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var secondCategoryIds, res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              // cascader 多选值为路径数组（[一级id, 二级id]），接口需要叶子（二级）id 数组
              secondCategoryIds = _this0.ticketSearchForm.second_category_id.map(function (path) {
                return path.length ? path[path.length - 1] : null;
              });
              _context7.n = 1;
              return getProjectTicketInitiatedList({
                work_order_no: _this0.ticketSearchForm.work_order_no,
                title: _this0.ticketSearchForm.title,
                second_category_id: secondCategoryIds,
                item: _this0.ticketSearchForm.item,
                page: _this0.ticketSearchForm.page,
                pageSize: _this0.ticketSearchForm.pageSize
              });
            case 1:
              res = _context7.v;
              _this0.ticketListData = res.data.data || [];
              _this0.ticketListPages = res.pages || {
                currentPage: 1,
                totalCount: 0
              };
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    ticketResetList: function ticketResetList() {
      this.ticketSearchForm.page = 1;
      this.getTicketList();
    },
    handleTicketPageChange: function handleTicketPageChange(page) {
      this.ticketSearchForm.page = page;
      this.getTicketList();
      var dom = document.getElementById('ticketSearchDom');
      dom.scrollIntoView();
    },
    ticketSizeChange: function ticketSizeChange(size) {
      this.ticketSearchForm.pageSize = size;
      this.ticketSearchForm.page = 1;
      this.getTicketList();
    },
    openTicketDrawer: function openTicketDrawer() {
      this.ticketFormId = null;
      this.ticketFormType = 'add';
      this.ticketDrawerVisible = true;
    },
    viewTicketDetail: function viewTicketDetail(row) {
      this.ticketFormId = row.id;
      this.ticketFormType = 'view';
      this.ticketFormCustomerName = row.customer_info && row.customer_info.company_name || '';
      this.ticketDrawerVisible = true;
    },
    handleTicketFormSuccess: function handleTicketFormSuccess() {
      this.ticketDrawerVisible = false;
      this.getTicketList();
    },
    // 拉取报价单订单列表与金额汇总（下单/查看订单共用）
    fetchSaleOrders: function fetchSaleOrders(row) {
      var _arguments = arguments,
        _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _ref, _ref$page, page, _ref$pageSize, pageSize, res, data, pages;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _ref = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref$page = _ref.page, page = _ref$page === void 0 ? 1 : _ref$page, _ref$pageSize = _ref.pageSize, pageSize = _ref$pageSize === void 0 ? 20 : _ref$pageSize;
              _context8.n = 1;
              return getSaleProjectDeliveryOrders({
                sale_project_delivery_id: row.project_delivery_id,
                page: page,
                pageSize: pageSize
              });
            case 1:
              res = _context8.v;
              data = res.data || {};
              _this1.saleOrderList = data.list || [];
              _this1.saleProjectDeliveryId = row.project_delivery_id;
              _this1.orderSummary = {
                quotation: data.sale_project_delivery_quotation_money,
                used: data.total_order_money,
                available: data.available_money
              };
              _this1.orderDrawerId = data.order_id;
              // 后端如返回分页信息则使用，否则以当前条数兜底
              pages = data.pages || {};
              _this1.orderListPages = {
                currentPage: pages.currentPage || page,
                totalCount: pages.totalCount !== undefined ? pages.totalCount : _this1.saleOrderList.length
              };
              return _context8.a(2, _this1.saleOrderList);
          }
        }, _callee8);
      }))();
    },
    // 下单：无订单为首次下单直接开创建订单页，有订单展示已下单明细再继续下单
    openOrderDialog: function openOrderDialog(row) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var list;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _this10.orderLoadingId = row.id;
              _context9.p = 1;
              _this10.viewOrderRow = row;
              _context9.n = 2;
              return _this10.fetchSaleOrders(row);
            case 2:
              list = _context9.v;
              if (!list.length) {
                _this10.createOrderDrawer = true;
              } else {
                _this10.selectedOrderId = list.length === 1 ? list[0].id : null;
                _this10.multiOrderVisible = true;
              }
            case 3:
              _context9.p = 3;
              _this10.orderLoadingId = null;
              return _context9.f(3);
            case 4:
              return _context9.a(2);
          }
        }, _callee9, null, [[1,, 3, 4]]);
      }))();
    },
    continueOrder: function continueOrder() {
      var _this11 = this;
      // 勾选订单为模板：创建订单页按其回显，提交也带该订单号
      this.orderDrawerId = this.selectedOrderId;
      this.multiOrderVisible = false;
      setTimeout(function () {
        _this11.createOrderDrawer = true;
      }, 300);
    },
    // 下单保存成功后关闭抽屉并刷新列表状态
    handleCreateOrderSuccess: function handleCreateOrderSuccess() {
      this.createOrderDrawer = false;
      this.getlist();
    },
    viewOrderList: function viewOrderList(row) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              _this12.orderLoadingId = row.id;
              _context0.p = 1;
              _this12.viewOrderRow = row;
              _context0.n = 2;
              return _this12.fetchSaleOrders(row);
            case 2:
              _this12.orderListVisible = true;
            case 3:
              _context0.p = 3;
              _this12.orderLoadingId = null;
              return _context0.f(3);
            case 4:
              return _context0.a(2);
          }
        }, _callee0, null, [[1,, 3, 4]]);
      }))();
    },
    handleViewOrderPageChange: function handleViewOrderPageChange(page) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              if (_this13.viewOrderRow) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2);
            case 1:
              _this13.orderListLoading = true;
              _context1.p = 2;
              _context1.n = 3;
              return _this13.fetchSaleOrders(_this13.viewOrderRow, {
                page: page
              });
            case 3:
              _context1.p = 3;
              _this13.orderListLoading = false;
              return _context1.f(3);
            case 4:
              return _context1.a(2);
          }
        }, _callee1, null, [[2,, 3, 4]]);
      }))();
    },
    goOrderDetail: function goOrderDetail(row) {
      var src = "".concat(this.$store.state.user.domainName, "/#/order/orderDetails?order_id=").concat(row.id);
      window.open(src, '_blank');
    }
  }
};